import React from 'react';
import PropTypes from 'prop-types';
import UnixTime from '../../unix-time';

export function UnixTimeRenderer(props) {
  const {cellData, format} = props;
  return (
    <span>
      <UnixTime value={cellData} format={format} />
    </span>
  );
}

UnixTimeRenderer.propTypes = {
  cellData: PropTypes.number,
  format: PropTypes.string,
};

export default function(format) {
  if (typeof format === 'object') {
    return UnixTimeRenderer(format);
  }
  return props => UnixTimeRenderer({format, ...props});
}
